module.exports = __webpack_public_path__ + "04_long_brown.882e9e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_long_brown.png
// module id = EqLd
// module chunks = 0